import { createClient } from "@supabase/supabase-js";
import type { Database } from "./database.types";

// Supabase client — singleton for the whole app.
// Anon key is safe to embed in frontend; row-level security is enforced
// server-side regardless.
const url  = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anon) {
  throw new Error(
    "Missing Supabase credentials. Copy .env.example to .env.local and fill in " +
    "VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY from your Supabase project settings.",
  );
}

export const supabase = createClient<Database>(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: "coretel-ops-auth",
  },
  global: {
    headers: { "x-application-name": "coretel-ops-web" },
  },
});

// The api-gateway Worker URL for file ops, OCR, etc.
// In dev points at localhost wrangler; in prod at api.coretelgroup.com.
export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? "https://api.coretelgroup.com";

// Helper: build an authenticated fetch to the Worker using the current session's access_token.
export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error("not_authenticated");

  return fetch(`${apiBaseUrl}${path}`, {
    ...init,
    headers: {
      ...(init.headers || {}),
      "Authorization": `Bearer ${session.access_token}`,
      "Content-Type":  "application/json",
    },
  });
}
